import { gsap } from '../../js/gsap.js';
import lenis from '../../js/scroll.js';

const selectors = {
  masthead: '.masthead',
  loaderLetter: '.wordmark-loader__letter',
  box: '.wordmark-loader__box',
  reveal: '.wordmark-loader__reveal',
  halfStart: '.wordmark-loader__half--start',
  halfEnd: '.wordmark-loader__half--end',
  flash: '[class*="wordmark-loader__picture--flash"]',
  wordmarkLetter: '.masthead__letter',
  navLink: '.main-nav a'
};

const state = {
  loading: 'is-loading',
  hidden: 'is-hidden'
};

function initMastheadIntro() {
  const container = document.querySelector(selectors.masthead);

  if (!container) return;

  const loaderLetter = container.querySelectorAll(selectors.loaderLetter);
  const box = container.querySelectorAll(selectors.box);
  const reveal = container.querySelectorAll(selectors.reveal);
  const halfStart = container.querySelectorAll(selectors.halfStart);
  const halfEnd = container.querySelectorAll(selectors.halfEnd);
  const flash = container.querySelectorAll(selectors.flash);
  const wordmarkLetter = container.querySelectorAll(selectors.wordmarkLetter);
  const navLinks = container.querySelectorAll(selectors.navLink);

  lenis.stop();

  const tl = gsap.timeline({
    defaults: {
      ease: 'expo.inOut'
    },
    onStart: () => {
      container.classList.remove(state.hidden);
    },
    onComplete: () => {
      container.classList.remove(state.loading);
      lenis.start();
    }
  });

  if (loaderLetter.length) {
    tl.from(loaderLetter, {
      yPercent: 100,
      stagger: 0.025,
      duration: 1.25
    });
  }

  if (box.length) {
    tl.fromTo(box, { width: '0em' }, { width: '2.2em', duration: 1.25 }, '< 1.25');
  }

  if (reveal.length) {
    tl.fromTo(reveal, { width: '0%' }, { width: '100%', duration: 1.25 }, '<');
  }

  if (halfStart.length) {
    tl.fromTo(halfStart, { x: '0em' }, { x: '-0.05em', duration: 1.25 }, '<');
  }

  if (halfEnd.length) {
    tl.fromTo(halfEnd, { x: '0em' }, { x: '0.05em', duration: 1.25 }, '<');
  }

  if (flash.length) {
    tl.fromTo(
      flash,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 0.05,
        ease: 'none',
        stagger: 0.55
      },
      '-=0.05'
    );
  }

  if (reveal.length) {
    tl.to(reveal, { width: '100vw', height: '100dvh', duration: 2 }, '< 1.85');
  }

  if (box.length) {
    tl.to(box, { width: '110vw', duration: 2 }, '<');
  }

  if (wordmarkLetter.length) {
    tl.from(
      wordmarkLetter,
      {
        yPercent: 100,
        duration: 1.25,
        ease: 'expo.out',
        stagger: 0.025
      },
      '< 1.2'
    );
  }

  if (navLinks.length) {
    tl.from(
      navLinks,
      {
        yPercent: 100,
        duration: 1.25,
        ease: 'expo.out',
        stagger: 0.1
      },
      '<'
    );
  }
}

// Fonts settle first, otherwise the loader word measures at fallback metrics.

document.fonts.ready.then(initMastheadIntro);
